import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Carfax(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="black" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M12.2285 18C8.82815 18 7 15.4444 7 12C7 8.25926 9.15722 6 12.2468 6C15.0622 6 16.1773 7.22222 16.9634 9.42593L14.075 10.5741C13.6728 9.5 13.2706 8.81481 12.2285 8.81481C10.894 8.81481 10.3272 10.1667 10.3272 12C10.3272 13.7778 10.8757 15.2037 12.2651 15.2037C13.2706 15.2037 13.691 14.6481 14.3126 13.5556L17 15C16.2139 16.537 14.9342 18 12.2285 18Z"
        fill="white"
      />
    </svg>
  );
}

Carfax.propTypes = propTypes;
Carfax.defaultProps = defaultProps;

export default Carfax;
